<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap">
      <v-flex class="pa-0">
        <v-layout class="section_01 ma-0">
          <v-flex class="left_section">
            <h2 class="section_inner_title">{{$t('main.new_registration.title')}}</h2>
            <p><br /></p>
            <v-layout class="card__sections__wrapper__main">
              <v-flex class="card_sections">
                <v-btn color="#faf3f4" fab width="100px" height="100px" class="mb--12"
                  @click="fnGoService('patent')"
                >
                  <v-img class="abt_icon" src="~@/assets/img/main_section_icon01.png"/>
                </v-btn>
                <p class="desc">{{$t('main.new_registration.patent')}}</p>
              </v-flex>

              <v-flex class="card_sections">
                <v-btn color="#faf3f4" fab width="100px" height="100px" class="mb--12"
                  @click="fnGoService('um')"
                >
                  <v-img class="abt_icon" src="~@/assets/img/main_section_icon02.png"/>
                </v-btn>
                <p class="desc">{{$t('main.new_registration.utility_model')}}</p>
              </v-flex>
              <v-flex class="card_sections">
                <v-btn color="#faf3f4" fab width="100px" height="100px" class="mb--12"
                  @click="fnGoService('ic')"
                >
                  <v-img class="abt_icon" src="~@/assets/img/main_section_icon03.png"/>
                </v-btn>
                <p class="desc mty2">{{$t('main.new_registration.layout_design_integrated_circuit')}}</p>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex class="right_section">
            <v-card
              class="card_custom01 ma-0"
              max-width="260"
              tile
              flat
            >
              <v-img height="100%" src="~@/assets/img/card_bg.jpg">
                <v-layout
                  align="end"
                  class="fill-height ma-0"
                >
                  <v-flex
                    align-self="start"
                    class="pa-40 inner_socket fill-height"
                    cols="12"
                  >
                    <v-list-item
                      class="pa-0 fill-height"
                      color="rgba(0, 0, 0, .4)"
                      dark
                    >
                      <v-list-item-content class="pa-0 fill-height">
                          <v-list-item-title class="title mb-15">{{$t('main.fields.pay_annual_fee')}}</v-list-item-title>
                          <v-list-item-subtitle class="subj white-space-normal"></v-list-item-subtitle>
                          <v-btn class="empty_btn page_view_btn" @click="fnGoService('payannualfee')">{{$t('main.fields.page_view')}}</v-btn>
                      </v-list-item-content>
                    </v-list-item>
                  </v-flex>
                </v-layout>
              </v-img>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout class="section_02 ma-0 mt-30">
          <v-flex class="pa-0 eservice_main_search_wrap">
            <v-flex class="first_chd">
              <v-icon class="mdi_icon01" :class="{ 'ml-40' : !$vuetify.rtl, 'mr-40' : $vuetify.rtl}"></v-icon>
              <v-subheader class="title">{{$t('main.patent_search')}}</v-subheader>
            </v-flex>
            <v-spacer class="hidden_lr35"></v-spacer>
            <v-flex class="seach_from_wrap">
              <v-text-field
                solo="solo"
                flat="flat"
                hide-details="hide-details"
                :label="$t('main.fields.enter_search_term')"
                class="custom-serach2"
                v-model="searchString" />
              <v-btn class="subm_btn" icon>
                <v-icon color="#770a15" @click="fnSearch">mdi-magnify</v-icon>
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout class="section_03 ma-0 mt-30">
          <v-flex class="line_inner_40">
            <h2 class="section_inner_title">{{$t('main.public_service.title')}}</h2>
            <v-row class="public__service__sections">
              <v-col cols="12" md="4"><v-btn color="#a01c2a" height="98" dark outlined rounded class="text-capitalize wp100" @click="fnGoService('research')"><i class="md_icon md_icon01"></i>{{$t('main.public_service.research_service')}}</v-btn></v-col>
              <v-col cols="12" md="4" class="nc__whnormal"><v-btn color="#a01c2a" height="98" dark outlined rounded class="text-capitalize wp100" @click="fnGoService('writingandprinting')"><i class="md_icon md_icon02"></i>{{$t('main.public_service.application_writing_printing_service')}}</v-btn></v-col>
              <v-col cols="12" md="4"><v-btn color="#a01c2a" height="98" dark outlined rounded class="text-capitalize wp100" @click="fnGoService('certifiedcopyservice')"><i class="md_icon md_icon03"></i>{{$t('main.public_service.certified_copy_service')}}</v-btn></v-col>
            </v-row>

            <v-row class="public__service__sections">
              <v-col cols="12" md="4" class="nc__whnormal ty2"><v-btn color="#a01c2a" height="98" dark outlined rounded class="text-capitalize wp100" @click="fnGoService('translationandaudit')"><i class="md_icon md_icon04"></i>{{$t('main.public_service.translation_audit_service')}}</v-btn></v-col>
              <v-col cols="12" md="4"><v-btn color="#a01c2a" height="98" dark outlined rounded class="text-capitalize wp100" @click="fnGoService('scanning')"><i class="md_icon md_icon05"></i>{{$t('main.public_service.scanning_service')}}</v-btn></v-col>
              <v-col cols="12" md="4"><v-btn color="#a01c2a" height="98" dark outlined rounded class="text-capitalize wp100" @click="fnGoService('inpersonmeeting')"><i class="md_icon md_icon06"></i>{{$t('main.public_service.in_person_meeting_request')}}</v-btn></v-col>
            </v-row>

          </v-flex>
        </v-layout>

        <v-layout class="section_04 ma-0 mt-30">
          <v-flex class="line_inner_40">
            <h2 class="section_inner_title d-flex justify-space-between">
              {{ $t('main.fields.faqs') }}
              <v-btn small style="background: rgba(0,0,0,0)" @click="fnGoService('faqs')">+more</v-btn>
            </h2>
            <v-card flat max-width="100%" class="mx-auto">
              <v-list>
                <template v-for="(item, index) in faqList">
                  <v-list-group append-icon="" class="list_group_item" active-class="actv" :key="index">
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div class="d-flex align-center justify-md-space-between">
                            <div>
                              Q. {{ $vuetify.rtl ? item.subject_ar : (fnIsNull(item.subject_en) ? item.subject_ar : item.subject_en) }}
                            </div>
                            <div class="appd__icon">
                              <v-icon>mdi-plus</v-icon>
                              <v-icon>mdi-minus</v-icon>
                            </div>
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="($vuetify.rtl) ? item.content_ar : (fnIsNull(item.content_en) ? item.content_ar : item.content_en)">
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="section_05 ma-0 mt-30 justify-space-between">
          <v-btn class="item_list" height="68" color="#d2d2d2" dark outlined @click="fnGoService('schedule')">
            <v-icon>mdi-calendar-blank</v-icon><v-spacer class="hidden_lr10 d-inline-block"></v-spacer>{{$t('main.fields.fee_schedule')}}
          </v-btn>
          <v-btn class="item_list" height="68" color="#d2d2d2" dark outlined @click="fnGoService('downloadforms')">
            <v-icon>mdi-download</v-icon><v-spacer class="hidden_lr10 d-inline-block"></v-spacer>{{$t('main.fields.download_forms')}}
          </v-btn>
          <v-btn class="item_list" height="68" color="#d2d2d2" dark outlined @click="fnGoService('userguide')">
            <v-icon>mdi-notebook-multiple</v-icon><v-spacer class="hidden_lr10 d-inline-block"></v-spacer>{{$t('main.fields.e_service_user_guide')}}
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <confirm-dialog :id="id" @confirm="fnGoPath2" />
    <v-dialog
      v-model="popupDialog"
      flat
      persistent
      max-width="500"
      content-class="br_none"
    >
      <v-card>
        <v-card-title class="headline">{{popupTitle}}</v-card-title>
        <v-card-text class="d-flex align-center justify-center"><span v-html="popupText" style="color:#000; font-size:16px!important;word-break:break-word;"></span></v-card-text>
        <v-card-actions class="d-flex align-center justify-center pb-15">
          <v-spacer></v-spacer>
          <v-btn class="sb_btn" width="110" @click="popupDialog = false" dark color="#2a58ad">{{ $t('common.button.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/layout/ConfirmDialog'
import requestApi from "@/utils/requestApi"
import utils from "@/utils/utils"
import eventBus from "@/utils/eventBus"
import store from '@/store'

export default {
  components: {
    ConfirmDialog
  },
  data() {
    return {
      id: 'Main',
      dialog: false,
      drawer: null,

      // FAQS
      faqList : [],

      searchString: '',
      searchUrl: process.env.VUE_APP_SEARCH_URL,
      popupDialog: false,
      popupTitle: '',
      popupText: '',
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.fnGetFaqList()
    this.fnGetPopup()
  },
  methods: {
    fnSearch() {
      window.open(this.searchUrl +'"'+ this.searchString +'"', '_blank', '')
    },
    fnGetFaqList() {
      let params = {
        searchType: "7002", // eService System
        searchKeyword: "",
        limit: 3
      };
      requestApi({
        url: "/info/faqs",
        method: "GET",
        data: params,
        callback: (res) => {
          if (res.res_code === "200") {
            this.faqList = res.data.list
          } else {
            if (res.res_code === "401012") {
              utils.setTokenRefresh().then(() => {
                this.fnGetFaqList()
              });
            } else {
              eventBus.$emit("SHOW_ERROR_SNACKBAR", res);
            }
          }
        },
      })
    },

    fnGetPopup () {
      requestApi({
        url: '/common/popup/3301',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if (res.data) {
              this.popupTitle = res.data.title
              this.popupText = res.data.contents
              this.popupDialog = true
            }
          } else {
            if (res.res_code === "401012") {
              utils.setTokenRefresh().then(() => {
                this.fnGetPopup()
              });
            } else {
              eventBus.$emit("SHOW_ERROR_SNACKBAR", res);
            }
          }
        }
      })
    },

    fnIsNull(val){
      return utils.isNull(val)
    },
    fnGoService(code){
      if(code === 'research' || code === 'patent' || code === 'ic' || code === 'um'){
        this.fnGoPath(code)
      }else if(code == 'writingandprinting'){
        this.fnGoCheck('/public/writingandprinting')
      }else if(code === 'certifiedcopyservice'){
        this.fnGoCheck('/public/certifiedcopyservice')
      }else if(code === 'translationandaudit'){
        this.fnGoCheck('/public/translationandaudit')
      }else if(code === 'scanning'){
        this.fnGoCheck('/public/translationandaudit')
      }else if(code === 'inpersonmeeting'){
        this.fnGoCheck('/public/inpersonmeeting')
      }else if(code === 'schedule'){
        this.$router.push('/information/fee')
      }else if(code === 'downloadforms'){
        this.$router.push('/information/forms')
      }else if(code === 'userguide'){
        this.$router.push('/information/userguide')
      }else if(code === 'faqs'){
        this.$router.push('/information/faqs')
      } else if (code === 'payannualfee') {
        this.fnGoCheck('/maintenance/payannualfee')
      }
    },
    fnGoCheck(path){
      if(utils.isNull(store.state.token.access_token)){
        this.$router.push('/signin?return_url=' + path)
      } else {
        this.$router.push(path)
      }
    },

    fnGoPath (code) {
      if(utils.isNull(store.state.token.access_token)){
        this.$router.push('/signin')
        return
      }

      let blnConfirm = false
      let tit = this.$t('common.common.confirm')
      let txt = ''
      let path = ''
      let url = '' // 신청 url

      if (code === 'temporary') {
        blnConfirm = true
        txt = this.$t('menu.new_application.confirm.temporary_protection')
        path = '/application/temporaryprotection/step1'
        url = '/receivings/temporary'
      } else if (code === 'patent') {
        blnConfirm = true
        txt = this.$t('menu.new_application.confirm.patent')
        path = '/application/patent/step1'
        url = '/receivings/patent'
      } else if (code === 'um') {
        blnConfirm = true
        txt = this.$t('menu.new_application.confirm.utility_model')
        path = '/application/utilitymodel/step1'
        url = '/receivings/utility/model'
      } else if (code === 'ic') {
        blnConfirm = true
        txt = this.$t('menu.new_application.confirm.ic_topography')
        path = '/application/ictopography/step1'
        url = '/receivings/ic'
      } else if (code === 'research') {
        blnConfirm = true
        txt = this.$t('menu.public_service.confirm.research_service')
        path = '/public/research/step1'
        url = '/receivings/research'
      }

      if (blnConfirm) {
        let options = {
          title: tit,
          text: txt,
          yes: {
            text: this.$t('common.button.yes'),
            event: 'confirm',
            callback: {
              path: path,
              url : url
            }
          },
          no: {
            text: this.$t('common.button.no')
          }
        }
        eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)
      }
    },

    // 메뉴에서 컨펌에 동의 했을 시에 신청 후에 url에 receipt_no가 넘어가도록 변경
    fnGoPath2 (callback) {
      requestApi({
        url: callback.url,
        method: 'POST',
        callback: (res) => {
          if (res.res_code === '200') {
            this.$router.push(callback.path + '/' + res.data.receipt_no)
            eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
            this.slideactive = false
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGoPath2(callback)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

  }
}
</script>